import * as React from 'react';
import { useIntl } from 'react-intl';
import CircularProgress from '@mui/material/CircularProgress';
import { LocationWithGalleryImages } from 'locations/lib/types';
import * as styles from 'core/components/LocationBookingCalendar/LocationBookingCalendar.module.scss';

export type LocationBookingCalendarProps = {
    location: LocationWithGalleryImages;
};

function LocationBookingPlaceholder({
    location,
}: LocationBookingCalendarProps): React.ReactElement {
    const wrapperRef = React.useRef<HTMLDivElement>(null);

    const intl = useIntl();

    return (
        <div className={styles.root}>
            <div className={styles.wrapper} ref={wrapperRef}>
                <div className={styles.title}>
                    <h4>
                        {intl.formatMessage({
                            id: 'booking.locationForm.title',
                        })}
                    </h4>
                    <h3>{location?.name}</h3>
                </div>
                <div className={styles.grid}>
                    <div className={styles.loading}>
                        <CircularProgress
                            size={100}
                            color="secondary"
                            aria-label={intl.formatMessage({
                                id: 'booking.locationForm.loadingDates',
                            })}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LocationBookingPlaceholder;
